import React, { Fragment } from 'react';
import Script from 'next/script';

const Klarna = () => (
  <Fragment>
    <Script
      async
      src="https://js.klarna.com/web-sdk/v1/klarna.js"
      data-environment={`${process.env.KLARNA_ENVIRONMENT}`}
      data-client-id={`${process.env.KLARNA_CLIENT_ID}`}
    />
    <Script
      async
      src="https://x.klarnacdn.net/kp/lib/v1/api.js"
      data-environment={`${process.env.KLARNA_ENVIRONMENT}`}
      data-client-id={`${process.env.KLARNA_CLIENT_ID}`}
    />
  </Fragment>
);

export default Klarna;
